/**
 * Environment Configuration
 * Determines which API base URL to use based on the current environment
 */

// Try to import dev config (gitignored, may not exist)
// This file is optional and only used in development
// Note: We use a dynamic require pattern that Webpack can't statically analyze
let devApiBaseUrl = null;

// Only try to load dev config in non-CI, non-production environments
// Webpack will try to resolve require() at build time, so we need to be careful
if (!process.env.CI && process.env.NODE_ENV !== 'production') {
  try {
    // Use a dynamic path that Webpack can't statically analyze
    const devConfigPath = './environment.dev.js';
    // eslint-disable-next-line import/no-unresolved
    const devConfig = require(devConfigPath);
    devApiBaseUrl = devConfig?.DEV_API_BASE_URL || null;
  } catch (e) {
    // Dev config doesn't exist, use defaults
    // This is expected in CI/production environments
    devApiBaseUrl = null;
  }
}

// Get environment from process.env or default to 'development'
const getEnvironment = () => {
  // Check if we're in production build
  if (process.env.NODE_ENV === 'production') {
    // Check for custom environment variable
    return process.env.REACT_APP_ENV || 'production';
  }
  // Check for custom environment variable in development
  return process.env.REACT_APP_ENV || 'development';
};

const environment = getEnvironment();

// API Base URLs for different environments
// Use dev config if available, otherwise use defaults
const getDefaultDevUrl = () => {
  // Use dev config if it exists, otherwise use default
  return devApiBaseUrl || 'http://localhost:8080/api';
};

const API_BASE_URLS = {
  development: getDefaultDevUrl(),
  test: getDefaultDevUrl(),
  // Production always uses environment variable or production URL
  production: process.env.REACT_APP_API_URL || 'https://safar-glimpse-service.fly.dev/api',
};

// Get the API base URL for the current environment
let resolvedApiBaseUrl = API_BASE_URLS[environment] || API_BASE_URLS.development;

// In development/test: if served from localhost, use dev config or default localhost
// Production is never affected by this logic
if (environment !== 'production') {
  try {
    if (typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost') {
      // Use dev config if available, otherwise use default
      resolvedApiBaseUrl = devApiBaseUrl || 'http://localhost:8080/api';
    }
  } catch (_) {
    // noop
  }
}

export const API_BASE_URL = resolvedApiBaseUrl;

// Environment info
export const ENV_CONFIG = {
  environment,
  apiBaseUrl: API_BASE_URL,
  isDevelopment: environment === 'development',
  isTest: environment === 'test',
  isProduction: environment === 'production',
};

// Log environment info in development
if (environment === 'development') {
  console.log('🌍 Environment:', environment);
  console.log('🔗 API Base URL:', API_BASE_URL);
}

export default ENV_CONFIG;

